var map = {
	"./address-book.svg": "054b",
	"./arrow-down.svg": "c874",
	"./arrow-left.svg": "ac3b",
	"./arrow-right.svg": "cd8c",
	"./calendar.svg": "b8bd",
	"./caret-down.svg": "3f24",
	"./check-outlined-round.svg": "7e5f",
	"./check-outlined.svg": "54a6",
	"./clear.svg": "c8de",
	"./close-circle-fill.svg": "b329",
	"./close.svg": "8b1b",
	"./copy.svg": "8aac",
	"./delete.svg": "0d45",
	"./double-arrow-left.svg": "cb15",
	"./double-arrow-right.svg": "5ddd",
	"./download.svg": "f28e",
	"./exclamation-circle-fill.svg": "ce84",
	"./eye-invisible.svg": "38d2",
	"./eye.svg": "7364",
	"./hot.svg": "abee",
	"./info-filled.svg": "22e7",
	"./language.svg": "a25c",
	"./loading.svg": "1e31",
	"./search.svg": "d103",
	"./star.svg": "cc90",
	"./swap.svg": "b008",
	"./telegram.svg": "2b29",
	"./tip.svg": "2e0c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ce4";